import { handleActions } from 'redux-actions';
import { POLICY_STATUS } from '../constants';
import { POWERUP_TYPE }
  from '../components/changeCoverage/powerups/powerups.constans';

const INITIAL_SELECTED_VALUES = {
  annualAmountPlan: 0,
  coverageName: 'Accident & Illness', // WIP prop103: for testing
  coveragePlanId: -1,
  coverageType: 1, // WIP prop103: for testing
  deductibleDescription: '',
  deductibleId: 0,
  isMonthly: true,
  loadingOverview: false,
  modifiers: [],
  monthlyAmountPlan: 0,
  petQuoteId: 0,
  reimbursementDescription: '',
  reimbursementId: 0,
  selectedAnnualBenefit: 0,
  selectedPlan: 0,
  total: 0,
  totalAnnual: 0,
  totalMonthly: 0,
};

const ORCA_CHANGE_COVERAGE_STATE = {
  coverage: {
    selectedLimits: {
      coinsuranceId: 0,
      coverageLimitId: 0,
      coverageType: 0, // ipg policies
      deductibleId: 0,
      incidentLimitId: 0,
    },
  },
  customer: {},
  effectiveOn: '',
  error: false,
  expiresOn: '',
  loading: true,
  orcaMarketChannelId: 0,
  petId: 0,
  petName: '',
  pets: [],
  previewData: {
    coinsuranceLimit: {
      display: '',
      id: 0,
      value: 0,
    },
    coverageLimit: {
      display: '',
      id: 0,
      value: 0,
    },
    deductibleLimit: {
      display: '',
      id: 0,
      value: 0,
    },
    incidentLimit: {
      display: '',
      id: 0,
      value: 0,
    },
    monthlyPreviewResults: [{
      isMandatory: false,
      monthlyInstallment: 0,
      stateFilingProductId: 0,
    }],
    productSelected: {
      code: '',
      display: '',
      stateFilingProductId: 0,
    },
  },
  products: {
    baseProducts: [{
      code: 0,
      display: '',
      limits: {
        coinsuranceLimits: [{
          display: '',
          id: 0,
          value: 0,
        }],
        coverageLimits: [{
          display: '',
          id: 0,
          value: 0,
        }],
        deductibleLimits: [{
          display: '',
          id: 0,
          value: 0,
        }],
        incidentLimits: [{
          display: '',
          id: 0,
          value: 0,
        }],
      },
      productId: 0,
    }],
    wellnessOptions: [{
      code: '',
      display: '',
      productId: 0,
    }],
  },
  proxyPolicy: {
    customer: {
      address1: '',
      address2: '',
      city: '',
      customerId: '',
      email: '',
      firstName: '',
      lastName: '',
      localizationCode: '',
      phone: '',
      postalCode: '',
      salesforceId: null,
    },
    customerPaymentOption: {
      bankName: '',
      cardTypeId: 0,
      customerPaymentOptionId: 0,
      expiresOn: '',
      last4: '',
      paymentTypeId: 0,
    },
    policyId: 0,
    policyTerms: [{
      policyTermId: 0,
    }],
  },
  quoteGuid: '',
  quotePreview: {
    Accident_Illness: [{
      monthlyInstallment: 0,
      stateFilingProductId: 0,
    }],
    AccidentOnly: [{
      monthlyInstallment: 0,
      stateFilingProductId: 0,
    }],
  },
  quoteStatusDisplay: '',
  selectedLimits: {
    coinsuranceId: 0,
    coverageLimitId: 0,
    deductibleId: 0,
    incidentLimitId: 0,
  },
  selectedProductCode: '',
  selectedWellness: null,
  stateFilingId: 0,
  submitQuote: null,
  wellnessOptionsDetails: [],
};

const INITIAL_STATE = {
  allPets: [],
  allPolicies: null,
  careCredit: {
    careCreditUrl: '',
    hasCareCreditUrl: false,
    loading: false,
  },
  changeCoverage: {
    cancelMultibrandPolicy: {
      error: false,
      loading: false,
      success: false,
    },
    cancelRenewalLoading: false,
    cancelRenewalModalVisible: false,
    cancelRenewalRequestSent: false,
    deductibleLegend: '',
    error: false,
    initialCoverageValues: INITIAL_SELECTED_VALUES,
    loading: false,
    loadingPreview: false,
    loadingSubmit: false,
    multimodalData: null,
    multimodalDataError: false,
    powerUpLoadings: [],
    preview: {
      loaded: false,
    },
    quoteSelectedValues: INITIAL_SELECTED_VALUES,
    rate: {
      effectiveDate: null,
      error: false,
      insuranceProduct: null,
      petQuoteResponseList: [],
      rateCreated: false,
      zipCode: null,
    },
    reviewChangesVisible: false,
    success: false,
  },
  changeCoverageOrcaCanada: ORCA_CHANGE_COVERAGE_STATE,
  changeCoverageValidation: {
    isLoading: false,
    isSuccess: false,
    isValid: false,
    message: '',
  },
  data: [],
  defaultPolicy: null,
  error: null,
  isYoungPetModalVisible: false,
  loading: true,
  loadingDefaultPolicy: false,
  loadingOtherPolicy: false,
  loadingOverview: true,
  loadingPlanSummary: false,
  loadingPoliciesOverView: true,
  loadingSeeMoreInfo: false,
  loadingWhatWeCoverInfo: false,
  loggedInWithoutPets: false,
  multibrandPolicies: [],
  multiModalData: {},
  otherPolicyDetail: null,
  pets: [],
  planSummarySeeMoreInfo: [],
  policiesOverView: [],
  policyBenefits: [],
  policyNotifications: [],
  showPlanSummarySeeMore: false,
  waitingPeriods: null,
  whatWeCoverInfo: [],
};

export default handleActions({
  ALL_PETS_GROUPED: (state, { payload }) => ({
    ...state,
    allPets: payload,
  }),
  CANCEL_MULTIBRAND_POLICY: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      cancelMultibrandPolicy: {
        error: false,
        loading: true,
        success: false,
      },
    },
  }),
  CANCEL_MULTIBRAND_POLICY_ERROR: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      cancelMultibrandPolicy: {
        error: true,
        loading: false,
        success: false,
      },
    },
  }),
  CANCEL_MULTIBRAND_POLICY_SUCCESS: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      cancelMultibrandPolicy: {
        error: false,
        loading: false,
        success: true,
      },
    },
  }),
  CANCEL_RENEWAL_MODAL_VISIBLE_CHANGED: (state, { payload }) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      cancelRenewalLoading: false,
      cancelRenewalModalVisible: payload,
    },
  }),
  CHANGE_COVERAGE_MULTIMODAL_FAILED: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      multimodalData: null,
      multimodalDataError: true,
    },
  }),
  CHANGE_COVERAGE_MULTIMODAL_LOADED: (state, { payload }) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      multimodalData: payload,
      multimodalDataError: true,
    },
  }),
  CHANGE_COVERAGE_PREVIEW_LOADED: (state, { payload }) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      loading: false,
      loadingPreview: false,
      preview: {
        ...state.changeCoverage.preview,
        loaded: true,
        ...payload,
      },
    },
  }),
  CHANGE_DEDUCTIBLE_LEGEND: (state, { payload }) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      deductibleLegend: payload,
    },
  }),
  CLEAR_POLICY_NOTIFICATIONS: (state) => ({
    ...state,
    policyNotifications: [],
  }),
  COVERAGE_TYPE_CHANGED: (state, { payload }) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      quoteSelectedValues: {
        ...state.changeCoverage.quoteSelectedValues,
        coverageName: payload.coverageName,
        coverageType: payload.coverageType,
      },
    },
  }),
  DEDUCTIBLE_CHANGED: (state, { payload }) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      quoteSelectedValues: {
        ...state.changeCoverage.quoteSelectedValues,
        deductibleDescription: payload.description,
        deductibleId: payload.deductibleId,
      },
    },
  }),
  DO_LOGOUT: () => ({ ...INITIAL_STATE }),
  GET_CHANGE_COVERAGE_MULTIMODAL_DATA: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      multimodalData: null,
      multimodalDataError: false,
    },
  }),
  GET_CHANGE_COVERAGE_PREVIEW: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      loadingPreview: true,
    },
  }),
  GET_CHANGE_COVERAGE_PREVIEW_ERROR: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      error: true,
      loading: false,
      loadingPreview: false,
      preview: {
        ...state.changeCoverage.preview,
        loaded: false,
      },
    },
  }),
  GET_COVERAGE_PERIOD_FAILURE: (state) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      error: true,
      loading: false,
    },
  }),
  GET_COVERAGE_PERIOD_REQUEST: (state) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      error: false,
      loading: true,
    },
  }),
  GET_COVERAGE_PERIOD_SUCCESS: (state, { payload }) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      coverage: payload.coverage,
      customer: payload.customer,
      effectiveOn: payload.effectiveOn,
      error: false,
      expiresOn: payload.expiresOn,
      loading: false,
      orcaMarketChannelId: payload.marketChannelId,
      petId: payload.petId,
      petName: payload.petName,
      pets: payload.pets,
      quoteGuid: payload.quoteGuid,
      stateFilingId: payload.stateFilingId,
      wellnessOptionsDetails: payload.wellnessOptionsDetails,
    },
  }),
  GET_COVERAGE_QUOTE_PRODUCT_SUCCESS: (state, { payload }) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      previewData: payload.previewData,
      products: payload,
    },
  }),
  GET_HAS_CARE_CREDIT_URL: (state) => ({
    ...state,
    careCredit: {
      ...state.careCredit,
      loading: true,
    },
  }),
  GET_HAS_CARE_CREDIT_URL_FAILED: (state) => ({
    ...state,
    careCredit: {
      ...state.careCredit,
      error: true,
      loading: false,
    },
  }),
  GET_HAS_CARE_CREDIT_URL_SUCCESS: (state, { payload }) => ({
    ...state,
    careCredit: {
      ...state.careCredit,
      ...payload,
      loading: false,
    },
  }),
  GET_MULTIBRAND_DEFAULT_POLICY: (state) => ({
    ...state,
    defaultPolicy: null,
    loadingDefaultPolicy: true,
  }),
  GET_MULTIBRAND_DEFAULT_POLICY_ERROR: (state) => ({
    ...state,
    defaultPolicy: null,
    loadingDefaultPolicy: false,
  }),
  GET_MULTIBRAND_DEFAULT_POLICY_LOADED: (state, { payload }) => ({
    ...state,
    defaultPolicy: payload,
    loadingDefaultPolicy: false,
  }),
  GET_MULTIBRAND_POLICIES: (state) => ({
    ...state,
    loading: true,
    multibrandPolicies: [],
  }),
  GET_MULTIBRAND_POLICIES_ERROR: (state) => ({
    ...state,
    loading: false,
    multibrandPolicies: [],
  }),
  GET_MULTIBRAND_POLICIES_LOADED: (state, { payload }) => ({
    ...state,
    loading: false,
    multibrandPolicies: payload,
  }),
  GET_ORCA_COVERAGE_PREVIEW: (state) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      loading: true,
    },
  }),
  GET_ORCA_COVERAGE_PREVIEW_FAILED: (state) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      error: true,
      loading: false,
    },
  }),
  GET_ORCA_COVERAGE_PREVIEW_SUCCESS: (state, { payload }) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      error: false,
      loading: false,
      quotePreview: {
        ...state.changeCoverageOrcaCanada.quotePreview,
        [payload.selectedProductCode]: {
          ...payload,
        },
      },
    },
  }),
  GET_POLICY_DETAIL: (state) => ({
    ...state,
    loadingOtherPolicy: true,
    otherPolicyDetail: null,
  }),
  GET_POLICY_DETAIL_ERROR: (state) => ({
    ...state,
    loadingOtherPolicy: false,
  }),
  GET_POLICY_DETAIL_LOADED: (state, { payload }) => ({
    ...state,
    loadingOtherPolicy: false,
    otherPolicyDetail: payload,
  }),
  GET_PROXY_POLICY: (state) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      loading: true,
    },
  }),
  GET_PROXY_POLICY_FAILED: (state) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      error: true,
      loading: false,
    },
  }),
  GET_PROXY_POLICY_SUCCESS: (state, { payload }) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      loading: false,
      proxyPolicy: payload,
    },
  }),
  INITIAL_POWER_UPS: (state, { payload }) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      quoteSelectedValues: {
        ...state.changeCoverage.quoteSelectedValues,
        modifiers: payload.modifiers,
      },
    },
  }),
  LOAD_PLAN_SUMMARY_DETAILS: (state) => ({
    ...state,
    loadingPlanSummary: true,
    policyBenefits: [],
  }),
  LOAD_PLAN_SUMMARY_SEE_MORE_INFO_ATTEMPT: (state) => ({
    ...state,
    loadingSeeMoreInfo: true,
  }),
  LOAD_POLICIES_CARD_INFORMATION: (state, { payload }) => ({
    ...state,
    policiesWithCardInfo: state.data
      .filter((item) => (
        item.Policy.Status === POLICY_STATUS.active
        || item.Policy.Status === POLICY_STATUS.future
      )).map((item) => ({
        ...item,
        Policy: {
          ...item.Policy,
          last4: payload
            .find((value) => value.PolicyNumber === item.Policy.Number)
            .AccountNumber,
        },
      })),
  }),
  LOAD_POLICIES_OVERVIEW: (state) => ({
    ...state,
    loadingOverview: true,
  }),
  LOAD_WHAT_WE_COVER_INFO_ATTEMPT: (state) => ({
    ...state,
    loadingWhatWeCoverInfo: true,
  }),
  LOGGED_IN_WITHOUT_PETS_RESET: (state) => ({
    ...state,
    loggedInWithoutPets: false,
  }),
  MULTI_MODAL_DATA_LOADED: (state, { payload }) => ({
    ...state,
    multiModalData: payload,
  }),
  PETS_GROUPED: (state, { payload }) => ({
    ...state,
    pets: payload,
  }),
  PLAN_SUMMARY_SEE_MORE_CLICKED: (state, { payload }) => ({
    ...state,
    planSummarySeeMoreInfo: [],
    showPlanSummarySeeMore: payload,
  }),
  PLAN_SUMMARY_SEE_MORE_INFO_LOADED: (state, { payload }) => ({
    ...state,
    loadingSeeMoreInfo: false,
    planSummarySeeMoreInfo: payload,
  }),
  POLICIES_ERROR: (state, { payload }) => ({
    ...state,
    error: payload,
    loading: false,
  }),
  POLICIES_OVERVIEW_LOADED: (state, { payload }) => ({
    ...state,
    loadingOverview: false,
    loadingPoliciesOverView: false,
    policiesOverView: payload,
  }),
  POLICY_DETAIL_CLEANED: (state) => ({
    ...state,
    defaultPolicy: null,
    otherPolicyDetail: null,
  }),
  POLICY_DETAILS_BENEFITS_LOADED: (state, { payload }) => ({
    ...state,
    loadingPlanSummary: false,
    policyBenefits: Array.isArray(payload) ? payload : [],
  }),
  POLICY_NOTIFICATIONS_LOADED: (state, { payload }) => ({
    ...state,
    policyNotifications: payload,
  }),
  POWER_UP_SELECTED: (state, { payload }) => {
    const { quoteSelectedValues } = state.changeCoverage;
    const { id, isSelected } = payload;

    const oldModifiers = quoteSelectedValues.modifiers || [];
    const isNewModifier =
      !oldModifiers.find((oldModifier) => oldModifier.id === id);

    if (isNewModifier) {
      return {
        ...state,
        changeCoverage: {
          ...state.changeCoverage,
          quoteSelectedValues: {
            ...quoteSelectedValues,
            modifiers: [
              ...quoteSelectedValues.modifiers,
              { id, isSelected },
            ],
          },
        },
      };
    }

    return {
      ...state,
      changeCoverage: {
        ...state.changeCoverage,
        quoteSelectedValues: {
          ...quoteSelectedValues,
          modifiers: quoteSelectedValues.modifiers.map((modifier) => {
            if (modifier.id === id) {
              return { id, isSelected };
            }

            return modifier;
          }),
        },
      },
    };
  },
  QUOTE_POWER_UP_CHANGED: (state, { payload }) => {
    const { rate } = state.changeCoverage;
    const { id, isSelected } = payload;

    return {
      ...state,
      changeCoverage: {
        ...state.changeCoverage,
        rate: {
          ...rate,
          insuranceProduct: {
            ...rate.insuranceProduct,
            InsuranceModifiers:
              rate.insuranceProduct.InsuranceModifiers
                .map((item) => {
                  if (item.Id === id) {
                    return {
                      ...item,
                      IsSelected: isSelected,
                    };
                  }

                  return item;
                }),
          },
        },
      },
    };
  },
  QUOTE_TOTAL_RECALCULATED: (state) => {
    const { quoteSelectedValues, rate } = state.changeCoverage;
    if (!quoteSelectedValues.selectedPlan) {
      return state;
    }
    const selectedPlan = rate.petQuoteResponseList[0].Plans
      .find((plan) => plan.Plan === quoteSelectedValues.selectedPlan);
    const { AnnualPremium, MonthlyPremium } = selectedPlan.RatingOptions
      .find((rating) => rating.DeductibleId === quoteSelectedValues.deductibleId
        && rating.ReimbursementId === quoteSelectedValues.reimbursementId);
    return ({
      ...state,
      changeCoverage: {
        ...state.changeCoverage,
        quoteSelectedValues: {
          ...quoteSelectedValues,
          annualAmountPlan: AnnualPremium,
          monthlyAmountPlan: MonthlyPremium,
          total: Number(quoteSelectedValues.isMonthly
            ? MonthlyPremium
            : AnnualPremium).toFixed(2),
          totalAnnual: Number(AnnualPremium).toFixed(2),
          totalMonthly: Number(MonthlyPremium).toFixed(2),
        },
      },
    });
  },
  RATE_COVERAGE: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      error: false,
      initialCoverageValues: INITIAL_SELECTED_VALUES,
      loading: true,
      loadingSubmit: false,
      quoteSelectedValues: INITIAL_SELECTED_VALUES,
      rate: {
        ...state.changeCoverage.rate,
        error: false,
      },
      success: false,
    },
  }),
  RATE_COVERAGE_ERROR: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      loading: false,
      rate: {
        ...state.changeCoverage.rate,
        error: true,
      },
    },
  }),
  RATE_COVERAGE_SUCCESS: (state, { payload }) => {
    const [petQuote] = payload.petQuoteResponseList;
    const planSelected =
      petQuote.Plans.find((item) => item.Plan === petQuote.Plan);
    const modifierQuote = petQuote.modifiers || [];

    return {
      ...state,
      changeCoverage: {
        ...state.changeCoverage,
        initialCoverageValues: state
          .changeCoverage.initialCoverageValues.petQuoteId
          ? { ...state.changeCoverage.initialCoverageValues }
          : {
            annualAmountPlan: petQuote.annualPremium,
            coverageName: 'Accident & Illness', // WIP prop103: for testing
            coveragePlanId: planSelected?.CoveragePlanId,
            coverageType: 1, // WIP prop103: for testing
            deductibleDescription: petQuote.deductibleName,
            deductibleId: petQuote.Deductible,
            InsuranceModifiers: petQuote.InsuranceModifiers
              ?.filter((modifier) => modifier.InsuranceModifierTypeId
                === POWERUP_TYPE && modifier.IsVisible)
              .map((powerUp) => ({
                id: powerUp.Id,
                isIncluded: modifierQuote
                  .find((item) => item.id === powerUp.Id)?.isSelected || false,
                name: powerUp.AppText,
              })),
            isMonthly: true,
            modifiers: petQuote.modifiers,
            monthlyAmountPlan: petQuote.monthlyPremium,
            petQuoteId: petQuote.petQuoteId,
            reimbursementDescription: petQuote.ReimbursementName,
            reimbursementId: petQuote.Reimbursement,
            selectedAnnualBenefit: planSelected?.MaxAnnual,
            selectedPlan: petQuote.Plan,
            total: 0,
            totalAnnual: petQuote.annualPremium?.toFixed(2),
            totalMonthly: petQuote.monthlyPremium?.toFixed(2),
          },
        loading: false,
        rate: {
          ...state.changeCoverage.rate,
          error: false,
          rateCreated: true,
          ...payload,
        },
      },
    };
  },
  RATE_QUOTE_UPDATE_ATTEMPT: (state, { payload }) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      powerUpLoadings: [...state.changeCoverage.powerUpLoadings, payload.id],
    },
  }),
  RATE_QUOTE_UPDATE_LOADED: (state, { payload }) => {
    const { quoteSelectedValues, rate: {
      petQuoteResponseList,
    } } = state.changeCoverage;

    if (!quoteSelectedValues.selectedPlan) {
      return state;
    }

    const selectedPlan = petQuoteResponseList[0].Plans
      .find((plan) => plan.Plan === quoteSelectedValues.selectedPlan);
    const { AnnualPremium, MonthlyPremium } = selectedPlan.RatingOptions
      .find((rating) => rating.DeductibleId === quoteSelectedValues.deductibleId
        && rating.ReimbursementId === quoteSelectedValues.reimbursementId);

    return ({
      ...state,
      changeCoverage: {
        ...state.changeCoverage,
        powerUpLoadings: state.changeCoverage.powerUpLoadings
          .filter((id) => id !== payload.id),
        quoteSelectedValues: {
          ...quoteSelectedValues,
          annualAmountPlan: AnnualPremium,
          modifiers: petQuoteResponseList[0].modifiers,
          monthlyAmountPlan: MonthlyPremium,
          total: Number(quoteSelectedValues.isMonthly
            ? MonthlyPremium
            : AnnualPremium).toFixed(2),
          totalAnnual: Number(AnnualPremium).toFixed(2),
          totalMonthly: Number(MonthlyPremium).toFixed(2),
        },
      },
    });
  },
  REIMBURSEMENT_CHANGED: (state, { payload }) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      quoteSelectedValues: {
        ...state.changeCoverage.quoteSelectedValues,
        reimbursementDescription: payload.description,
        reimbursementId: payload.reimbursementId,
      },
    },
  }),
  REQUEST_CANCEL_RENEWAL: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      cancelRenewalLoading: true,
      cancelRenewalRequestSent: false,
    },
  }),
  REQUEST_CANCEL_RENEWAL_FAILED: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      cancelRenewalLoading: false,
      cancelRenewalRequestSent: false,
    },
  }),
  REQUEST_CANCEL_RENEWAL_SUCCESS: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      cancelRenewalLoading: false,
      cancelRenewalRequestSent: true,
    },
  }),
  RESET_CHANGE_COVERAGE_ORCA: (state) => ({
    ...state,
    changeCoverageOrcaCanada: ORCA_CHANGE_COVERAGE_STATE,
  }),
  RESTART_RATE: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      cancelRenewalModalVisible: false,
      cancelRenewalRequestSent: false,
      initialCoverageValues: INITIAL_SELECTED_VALUES,
      loading: false,
      powerUpLoadings: [],
      quoteSelectedValues: INITIAL_SELECTED_VALUES,
      rate: {
        error: false,
        rateCreated: false,
      },
    },
  }),
  REVIEW_CHANGES_VISIBLE_CHANGED: (state, { payload }) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      reviewChangesVisible: payload,
    },
  }),
  SAVE_ORCA_QUOTE: (state, { payload }) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      error: false,
      loading: true,
      selectedLimits: payload.selectedLimits,
      selectedProductCode: payload.selectedProductCode,
      selectedWellness: payload.selectedWellness || null,
    },
  }),
  SAVE_ORCA_QUOTE_FAILED: (state) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      error: true,
      loading: false,
    },
  }),
  SAVE_ORCA_QUOTE_RESET: (state) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      quoteStatusDisplay: '',
    },
  }),
  SAVE_ORCA_QUOTE_SUCCESS: (state, { payload }) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      error: false,
      loading: false,
      quoteStatusDisplay: payload.quoteStatusDisplay,
    },
  }),
  SELECTED_PLAN_CHANGED: (state, { payload }) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      quoteSelectedValues: {
        ...state.changeCoverage.quoteSelectedValues,
        coveragePlanId: payload.coveragePlanId,
        selectedAnnualBenefit: payload.selectedAnnualBenefit,
        selectedPlan: payload.planId,
      },
    },
  }),
  STORE_ALL_POLICIES: (state, { payload }) => ({
    ...state,
    allPolicies: Array.isArray(payload) ? payload : [],
    loggedInWithoutPets: payload.length === 0,
  }),
  STORE_POLICIES: (state, { payload }) => {
    const hasPolicies = Array.isArray(payload);

    return {
      ...state,
      data: hasPolicies ? payload : [],
      loading: false,
      loadingWhatWeCoverInfo: hasPolicies && hasPolicies.length > 0,
    };
  },
  SUBMIT_CHANGE_COVERAGE: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      error: false,
      loadingSubmit: true,
      rate: {
        ...state.changeCoverage.rate,
        error: false,
      },
      success: false,
    },
  }),
  SUBMIT_CHANGE_COVERAGE_FAILED: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      error: true,
      loadingSubmit: false,
      rate: {
        ...state.changeCoverage.rate,
        error: true,
      },
      reviewChangesVisible: false,
      success: false,
    },
  }),
  SUBMIT_CHANGE_COVERAGE_SUCCESS: (state) => ({
    ...state,
    changeCoverage: {
      ...state.changeCoverage,
      error: false,
      initialCoverageValues: INITIAL_SELECTED_VALUES,
      loadingSubmit: false,
      rate: {
        ...state.changeCoverage.rate,
        error: false,
      },
      reviewChangesVisible: false,
      success: true,
    },
  }),
  SUBMIT_COVERAGE_PERIOD: (state) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      error: false,
      loading: true,
    },
  }),
  SUBMIT_COVERAGE_PERIOD_FAILED: (state) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      error: true,
      loading: false,
    },
  }),
  SUBMIT_COVERAGE_PERIOD_SUCCESS: (state, { payload }) => ({
    ...state,
    changeCoverageOrcaCanada: {
      ...state.changeCoverageOrcaCanada,
      error: false,
      loading: false,
      submitQuote: payload,
    },
  }),
  VALIDATE_CHANGE_COVERAGE: (state) => ({
    ...state,
    changeCoverageValidation: {
      ...state.changeCoverageValidation,
      isLoading: true,
    },
  }),
  VALIDATE_CHANGE_COVERAGE_CLEARED: (state) => ({
    ...state,
    changeCoverageValidation: {
      ...state.changeCoverageValidation,
      isLoading: false,
      isSuccess: false,
      isValid: false,
      message: '',
    },
  }),
  VALIDATE_CHANGE_COVERAGE_FAILED: (state, { payload }) => ({
    ...state,
    changeCoverageValidation: {
      ...state.changeCoverageValidation,
      isLoading: false,
      isSuccess: true,
      isValid: payload.isValid,
      message: payload.message,
    },
  }),
  VALIDATE_CHANGE_COVERAGE_SUCCESS: (state, { payload }) => ({
    ...state,
    changeCoverageValidation: {
      ...state.changeCoverageValidation,
      isLoading: false,
      isSuccess: true,
      isValid: payload.isValid,
      message: '',
    },
  }),
  WAITING_PERIODS_LOADED: (state, { payload }) => ({
    ...state,
    waitingPeriods: payload,
  }),
  WHAT_WE_COVER_INFO_LOADED: (state, { payload }) => ({
    ...state,
    loadingWhatWeCoverInfo: false,
    whatWeCoverInfo: payload,
  }),
  YOUNG_PET_MODAL_CLOSED: (state) => ({
    ...state,
    isYoungPetModalVisible: false,
  }),
  YOUNG_PET_MODAL_OPEN: (state) => ({
    ...state,
    isYoungPetModalVisible: true,
  }),
}, INITIAL_STATE);
